// extracted by mini-css-extract-plugin
export default {"milestoneWrapper":"milestone_milestoneWrapper__S4qjo","milestoneBackground":"milestone_milestoneBackground__vRr3v"};